const relationshipList = [
  "Self 18+",
  "Mother",
  "Father",
  "Stepfather",
  "Stepmother",
  "Relative",
  "Grandparent",
  "GroupHome",
  "Foster Parent",
  "Foster Father",
  "Foster Mother",
  "Grandfather",
  "Grandmother",
  "Uncle",
  "Aunt",
  "Family Member",
  "Other Relationship",
  "Guardian",
  "Parents",
  "Caregiver",
  "Surrogate parent (for IEP)",
  "Agency Representative",
  "Other Relative",
  "Counselor",
  "Therapist",
  "DCFS Worker",
  "Probation Officer Therapist (Wrap-Around)",
];

export default relationshipList;
